<template>
  <div
    :class="[
      { 'text-justify': justify },
      { 'single-line': singleLine },
      {
        'w-100 d-flex align-items-center justify-content-between': spaceBetween
      },
      {
        'd-flex align-items-center flex-wrap': !justify && !spaceBetween
      }
    ]"
  >
    <font-awesome-icon
      v-if="icon"
      :class="iconClass"
      :icon="icon"
      class="ml-2"
    />

    <component :is="component" :class="[masterClass, labelClass]" class="ml-1">
      {{ label }} :
    </component>

    <component :is="component" :class="[masterClass, valueClass]">
      <template v-if="computedValue !== undefined">
        {{ computedValue !== null ? computedValue : '-' }}
      </template>

      <slot name="value"></slot>
    </component>

    <span
      v-if="computedValue !== null && unit"
      :class="unitClass"
      class="text-muted mr-1"
    >
      {{ unit }}
    </span>

    <slot name="append"></slot>
  </div>
</template>

<script>
export default {
  name: 'BrbLabelValue',
  props: {
    icon: String,
    iconClass: [String, Array, Object],
    label: String,
    labelClass: [String, Array, Object],
    value: {
      default: undefined
    },
    valueClass: [String, Array, Object],
    unit: String,
    unitClass: [String, Array, Object],
    masterClass: [String, Array, Object],
    justify: Boolean,
    singleLine: Boolean,
    spaceBetween: Boolean,
    valueOptions: {
      type: Array,
      default: () => []
    },
    component: {
      type: String,
      default: 'span'
    }
  },
  computed: {
    computedValue() {
      if (this.valueOptions && this.valueOptions.length) {
        const option = this.valueOptions.find(
          (option) => option.id === this.value
        )
        if (option && (option.title || option.label || option.text))
          return option.title || option.label || option.text
        return this.value
      }
      return this.value
    }
  }
}
</script>
